const dropShadow = {
    name: "drop-shadow",
    path: "/drop-shadow",
    title: "drop-shadow",
    description: "Utilities for applying drop-shadow filters to an element.",
    value: {
        'filter': {
            'drop-shadow-xs': 'drop-shadow(0 1px 1px rgb(0 0 0 / 0.15))',
            'drop-shadow-sm': 'drop-shadow(0 1px 2px rgb(0 0 0 / 0.15))',
            'drop-shadow-md': 'drop-shadow(0 3px 3px rgb(0 0 0 / 0.12))',
            'drop-shadow-lg': 'drop-shadow(0 4px 4px rgb(0 0 0 / 0.15))',
            'drop-shadow-xl': 'drop-shadow(0 9px 7px rgb(0 0 0 / 0.25))',
            'drop-shadow-2xl': 'drop-shadow(0 15px 15px rgb(0 0 0 / 0.35))',
            'drop-shadow-none': 'drop-shadow(0 0 #0000)',
            'drop-shadow-[<value>]': 'drop-shadow(<value>)',
        },
        '': {
            'drop-shadow-color-<color-name>': '--uni-drop-shadow-color: var(--<color-name>)',
            'drop-shadow-color-[<value>]': '--uni-drop-shadow-color: <value>',
        }
    },
    exampleData: [
        {
            "title": "contrast-50, contrast-100",
            "description": "to control an element's contrast:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass": "size-24 mx-auto rounded-lg drop-shadow-xs bg-color-white",
                        "className": "",
                        "text": "drop-shadow-xs",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg drop-shadow-lg bg-color-white",
                        "className": "",
                        "text": "drop-shadow-lg",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg drop-shadow-xl bg-color-white",
                        "className": "",
                        "text": "drop-shadow-xl",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg drop-shadow-[0_35px_35px_rgba(0,0,0,0.25)] bg-color-white",
                        "className": "",
                        "text": "drop-shadow-[0_35px_35px_rgba(0,0,0,0.25)]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<div class="drop-shadow-xs" />
<div class="drop-shadow-lg" />
<div class="drop-shadow-xl" />
<div class="drop-shadow-[0_35px_35px_rgba(0,0,0,0.25)]" />`
            }
        },
        {
            "title": "drop-shadow-color-purple-500/50, drop-shadow-color-[rgb(244_67_54_/50)]",
            "description": "to change the color of a drop shadow:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-2 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "divClass": "size-24 mx-auto rounded-lg drop-shadow-2xl drop-shadow-color-purple-500/50 bg-color-purple-500",
                        "className": "",
                        "text": "drop-shadow-color-purple-500/50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "divClass": "size-24 mx-auto rounded-lg drop-shadow-2xl drop-shadow-color-[rgb(244_67_54_/50)] bg-color-[#f44336]",
                        "className": "",
                        "text": "drop-shadow-color-[rgb(244_67_54_/50)]",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<div class="drop-shadow-xs" />
<div class="drop-shadow-2xl drop-shadow-color-purple-500/50" />
<div class="drop-shadow-2xl drop-shadow-color-[rgb(244_67_54_/50)]" />`
            }
        }
    ]
};

export default dropShadow;